import React, { createContext, useContext, useState } from "react";

const BookingCtx = createContext(null);

const initial = {
  ad_type: "public_notice",
  paper_id: "",
  paper: null,
  edition: "sambhajinagar",   // "sambhajinagar" | "other" (other triggers contact-us)
  publish_date: "",
  language: "",            // "english" | "marathi" | "hindi"
  ad_size: "",             // "4x10" | "3x5"
  ad_mode: "text",
  ad_text: "",
  ad_file_name: "",
  ad_file_data_url: "",
  letterhead_data_url: "",
  letterhead_name: "",
  // Change-of-Name specific
  con_subtype: "name_only",        // "name_only" | "name_and_dob"
  old_name: "",
  new_name: "",
  relation: "self",                 // "self" | "mother" | "father" | "child" (whose details are changing)
  army_no: "",
  rank_label: "",
  old_dob: "",                      // only used when subtype = name_and_dob
  new_dob: "",                      // only used when subtype = name_and_dob
  affidavit_number: "",
  affidavit_date: "",
  affidavit_file_name: "",
  affidavit_data_url: "",
  advocate: {
    name: "",
    profession: "",
    email: "",
    bar_id: "",
    contact_primary: "",
    contact_secondary: "",
    contact_tertiary: "",
    address: "",
  },
};

export function BookingProvider({ children }) {
  const [draft, setDraft] = useState(initial);
  const update = (patch) => setDraft((d) => ({ ...d, ...patch }));
  const updateAdvocate = (patch) =>
    setDraft((d) => ({ ...d, advocate: { ...d.advocate, ...patch } }));
  const reset = () => setDraft(initial);
  return (
    <BookingCtx.Provider value={{ draft, update, updateAdvocate, reset }}>
      {children}
    </BookingCtx.Provider>
  );
}
export const useBooking = () => useContext(BookingCtx);
